<script setup lang="ts">
import { defaultAvailableLangs } from '@/locales/i18n'
import {
    EContextProvider,
    EEnv,
    EProviders,
    type VersionItem
} from '@rfc/rfc-components-library/types'
import { provide } from 'vue'
import { RouterView } from 'vue-router'
import AdminContextProvider from './AdminContextProvider.vue'
import DetectionContextProvider from './DetectionContextProvider.vue'
import DeviceContextProvider from './DeviceContextProvider.vue'
import HubContextProvider from './HubContextProvider.vue'
import MenuProvider from './MenuProvider.vue'
import MyAccountProvider from './MyAccountProvider.vue'
import OrganizationContextProvider from './OrganizationContextProvider.vue'
import SocketContextProvider from './SocketContextProvider.vue'
import ThemeContextProvider from './ThemeContextProvider.vue'
import UserContextProvider from './UserContextProvider.vue'

const availableLangs = defaultAvailableLangs
const version = {
    env: import.meta.env.NODE_ENV as EEnv,
    version: import.meta.env.VITE_CURRENT_VERSION ?? import.meta.env.VITE_BUILD_VERSION
}

provide(EProviders.GLOBAL, {
    availableLangs,
    routerViewComponent: RouterView
})

provide<VersionItem>(EContextProvider.VERSION, version)
</script>

<template>
    <DeviceContextProvider>
        <MyAccountProvider>
            <SocketContextProvider>
                <UserContextProvider>
                    <OrganizationContextProvider>
                        <ThemeContextProvider>
                            <template #default="props">
                                <HubContextProvider>
                                    <DetectionContextProvider>
                                        <AdminContextProvider>
                                            <MenuProvider>
                                                <slot v-bind="props" />
                                            </MenuProvider>
                                        </AdminContextProvider>
                                    </DetectionContextProvider>
                                </HubContextProvider>
                            </template>
                        </ThemeContextProvider>
                    </OrganizationContextProvider>
                </UserContextProvider>
            </SocketContextProvider>
        </MyAccountProvider>
    </DeviceContextProvider>
</template>
